import { Navigate, useParams } from "react-router-dom";
import {  useGetAgendamiento } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";
import SaveSolicitudTecnicoAgendaPymes from "../../shared/componente/save_solicitud_tecnico_pymes/SaveSolicitudTecnicoAgendaPymes";

export default function EditSolicitudTecnicoPlantaExternaAgendaPage() {

  const { id } = useParams();

  const {
    data,
    isLoading,
  } = useGetAgendamiento(id!)

  if (isLoading)
    return <LoaderComponent />

  if (!data)
    return <Navigate to={ROUTER_PATHS.mantenimientoOperaciones.solicitudTecnicoPymesNav} />

  return <SaveSolicitudTecnicoAgendaPymes
    agendamiento={data?.data}
    title="Solicitud Técnico Agenda"
    router_path={ROUTER_PATHS.mantenimientoOperaciones.solicitudTecnicoPymesNav}
  />

}